import fr from 'facet-rest';
import React, {
  useState,
} from 'react';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useFooterContext } from 'Context/FooterContext';
import Portal from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Portal';
import BaseFormLayout from 'Components/ComponentLibrary/Templates/Unauthenticated/Content/BaseFormLayout';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';
import { pickFunction } from 'Helpers/Affordances';
import { useNewLoginContext } from '../../../NewLoginContext';

const styles = () => ({
  root: {},
});

const AuthAuthenticator = ({
  classes,
  className,
}) => {
  const { resource, onSubmit, unsourcedErrors } = useMetaLayoutContext();
  const { footerRef } = useFooterContext();
  const { handleSubmit } = useNewLoginContext();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const loginViaCode = async event => {
    setIsSubmitting(true);
    if (event) {
      event.preventDefault();
    }
    const coll = await onSubmit();
    if (coll) {
      await handleSubmit(coll);
    }
    setIsSubmitting(false);
  };

  const requestTextMessage = async event => {
    setIsSubmitting(true);
    if (event) {
      event.preventDefault();
    }

    const [mfaPreferenceRes] = await resource.relationship(fr.relationships.mfaPreference.name).link('related').get();
    mfaPreferenceRes.attr('preference', 'sms');
    const coll = await mfaPreferenceRes.submit();
    if (coll) {
      await handleSubmit(coll);
    }
    setIsSubmitting(false);
  };


  const renderTextButton = () => {
    return pickFunction(resource, {
      [fr.relationships.mfaPreference.name]: () => {
        return (
          <TextButton
            className={classNames(classes.root, className)}
            disableElevation
            disabled={isSubmitting}
            color={'primary'}
            variant={'underlined'}
            fullWidth
            onClick={requestTextMessage}
            test={'switch-to-sms-code'}
          >
            {'Text me a code instead'}
          </TextButton>
        );
      },
      [fr.relationships.default.name]: () => {
        return null;
      },
    });
  };

  return (
    <BaseFormLayout
      className={classNames(classes.root, className)}
      onSubmit={loginViaCode}
      id={'multi-factor-authentication-form-login'}
      title={'Login to your account'}
      subtitle={'Enter the one-time six digit code provided by your authentication app.'}
      errors={unsourcedErrors}
      message={resource.attr('message')}
    >
      <MetaField
        attr={'code'}
        inputProps={{
          test: 'mfa-code-field',
        }}
      />

      <MetaField
        attr={'rememberDevice'}
        test="remember-device-field"
      />

      <Portal container={footerRef.current}>
        <RoundedButton
          onClick={loginViaCode}
          disabled={isSubmitting}
          test={'login-button'}
          type={'submit'}
          form={'multi-factor-authentication-form-login'}
          fullWidth
        >
          {'Login'}
        </RoundedButton>
        {renderTextButton()}
      </Portal>
    </BaseFormLayout>
  );
};

AuthAuthenticator.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

AuthAuthenticator.defaultProps = {
  className: '',
};

export default withStyles(styles)(AuthAuthenticator);
